<template>
  <div class="home">
    <div class="frame">
        <div 
          id="gl" 
          data-imageOriginal="../assets/images/lady.jpg" 
          data-imageDepth="../assets/images/lady-map.jpg" 
          data-horizontalThreshold="35" 
          data-verticalThreshold="15">
        </div>
      <div class="frame__content"></div>
    </div>
    <h1>
        <span :class="[{'fadeInUp' : titulo, 'fadeOutUp' : !titulo},'animated']"><b>Impact (im·pact):</b> have a strong effect on someone or something.</span>
        <span :class="[{'fadeInUp' : titulo, 'fadeOutUp' : !titulo},'animated']">That's what we do.</span>
    </h1>
    <div :class="[{'fadeInUp on' : !titulo},'animated','content']">
      
    </div>

    <div class="sources" v-if="load">
			<div v-for="(project, index) of projects" :key="index">
        <img :src="'./assets/images/thumbs/'+project+'.jpg'" alt="the360.agency" />
		  </div>
		</div>

  </div>
</template>

<script>
import $ from 'jquery'
export default {
  name: 'home',
  data() {
    return{
      titulo: true,
      load: true,
      projects :[1,5,6,9,10,2,11,12,13,14,15,8,16,17,7,18,19,3,4,20,21,22,29,23,24,27,25,26,28,30]
    }
  },
  methods: {
    tituloTime(){
      setTimeout(() => {
        this.titulo = false;
      }, 3500);
    }
  }, 
  created() {
    $.getScript("../assets/js/fake3d.js");
    
    setTimeout(() => {
			this.load = false;
		}, 3000);
  }
}
</script>